

export const getUltimos = async() => {

    const entidad= localStorage.getItem('entidad') || null;

    if( entidad === null ) return [];

    const server_url=  process.env.REACT_APP_PRODUCCION;  
    const resp = await fetch(`${server_url}/ultimos/${entidad}`);

    const data = await resp.json();

  

    return (data.ultimos);

}